import * as yup from "yup";

const equipmentValidation = yup.object().shape({
  categoryId: yup.number().min(1, "Bu alan zorunludur"),
  modelId: yup.number().min(1, "Bu alan zorunludur"),
  serialNumber: yup.string().required("Bu alan zorunludur"),
});

export default equipmentValidation;
